var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6.72h.21L7.56 8.88a2.84 2.84 0 01.89-1.59 2.31 2.31 0 011.76-.57H10zm2.46 2.69a2.45 2.45 0 01-1 2 2.51 2.51 0 01-2.06.45l3.06-2.45zM10.02 4h.19a6.92 6.92 0 012.83.4l-1.41 1.19a3.63 3.63 0 00-1.58-.38c-3.5 0-4 3.79-4 4.08.006.236.036.47.09.7l-2.94 2.4a6.71 6.71 0 01-2.25-3.1C2.4 5.21 7.39 3.9 10.16 4h-.14zm6.5 2.1A7 7 0 0119 9.35c-1.12 2.79-4.34 5.53-9.88 5.29a7.271 7.271 0 01-2.48-.49c.32-.3.81-.7 1.46-1.2a3.73 3.73 0 001.75.51c1.33.16 4.6-1.14 3.91-5.12.95-.76 1.84-1.51 2.76-2.24zm.66-4.1l1.11 1.31L2.71 16.37l-1.1-1.31L17.18 2z",
    fill: "#CCC"
  })));
}
export default SvgEyeClose;